import { sp } from '@main/theme';
import { css } from 'styled-components';

/**
 * Global custom box-shadow styles to use throughout the Privacy Center,
 * for tab-able elements to support keyboard navigability
 */
export const standardFocusStyles = css`
  box-shadow:
    ${({ theme }) => theme.colors.lightPrimary} 0 0 1px 3px,
    ${({ theme }) => theme.colors.lightPrimary} 0 0 0 1px,
    ${({ theme }) => theme.colors.lightPrimary} 0 2px 6px 0,
    ${({ theme }) => theme.colors.lightPrimary} 0 1px 3.5px 0;
`;

/**
 * Global H1 css styles
 */
export const h1Fragment = css`
  font-family: '${({ theme }) => theme.textStyles.fontFamilyHeader.name}';
  font-weight: 600;
  font-size: ${sp(3.5)};
  ${({ theme }) => theme.componentStyles.h1};
`;

/**
 * Global H2 css styles
 * TODO: https://linear.app/transcend/issue/WAL-7008 - Make H2's configurable from Admin Dashboard
 */
export const h2Fragment = css`
  font-family: '${({ theme }) => theme.textStyles.fontFamilyHeader.name}';
  font-weight: 600;
  font-size: ${sp(2.5)};
  // Commenting this out for now so that the sidebar header is not affected by global h2 styles
  /* ${({ theme }) => theme.componentStyles.h2}; */
`;

/**
 * Global H3 css styles
 */
export const h3Fragment = css`
  font-family: '${({ theme }) => theme.textStyles.fontFamilyHeader.name}';
  font-weight: 600;
  font-size: ${sp(2.25)};
  ${({ theme }) => theme.componentStyles.h3};
`;

/**
 * Global body css styles
 */
export const bodyFragment = css`
  font-size: ${sp(2)};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textOnBg};
  ${({ theme }) => theme.componentStyles.body};
`;

/**
 * Global styles for core components
 */
export const coreComponentStyles = css`
  h1 {
    ${h1Fragment}
  }

  h2 {
    ${h2Fragment}
  }

  h3 {
    ${h3Fragment}
  }

  p {
    ${bodyFragment}
  }
`;
